import { ArchiveXIcon } from 'lucide-react';

import { Card, CardContent } from '@/components';

const Empty = ({ text = 'No Data Found!', size = 20, className = '' }) => {
  return (
    <div className={className}>
      <Card>
        <CardContent className={'my-6 flex flex-col items-center gap-4'}>
          <ArchiveXIcon size={size} className="text-muted-foreground" />
          <p className="text-muted-foreground text-center">{text}</p>
        </CardContent>
      </Card>
    </div>
  );
};

export default Empty;
